import React from "react";
import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import { barfboy } from "../components/SmallComponents/Images";
import { StyledNavButton } from "../components/SmallComponents/AppComponents";

function BuySection() {
  const matches = useMediaQuery("(max-width:950px)");

  return (
    <Box mb={2} py={{ md: 10, xs: 5 }} id="buy">
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 2, sm: 6 }} justifyContent={"center"}>
          <Grid
            item
            xs={12}
            md={4.5}
            order={{ xs: 2, md: 1 }}
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 3,
                width: matches ? "100%" : "80%",
                borderRadius: "24px",
                background: "#55CB01",
                boxShadow:
                  "0px 2px 4px 0px #0000004D inset,0px -2px 4px 0px #FFFFFF8C inset",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Lilita One",
                  fontSize: { xs: "24px", sm: "40px" },
                  color: "#fff",
                }}
              >
                How to buy BARFBOY
              </Typography>
              <Typography
                sx={{
                  my: 2,
                  fontFamily: "Montserrat",
                  fontSize: { xs: "16px", sm: "18px" },
                  color: "#fff",
                }}
              >
                1️⃣ Get a Wallet (Phantom Wallet https://phantom.com)
                <br />
                2️⃣ Load it with SOL
                <br />
                3️⃣ Swap for BARFBOY using the token contract
                <br />
                4️⃣ Hold, Chill & Watch the Madness Unfold
              </Typography>
              <Box mt={3}>
                <StyledNavButton
                  href="https://raydium.io/swap/?inputMint=sol&outputMint=mVuzEMo5n4p6iHNFGWsFkACB2F1vNmW8BdwoyKApump"
                  target="_blank"
                  width="200px"
                  bgColor="linear-gradient(180deg, #74A1FF 0%, #2E72FF 100%)"
                >
                  Buy BARFBOY
                </StyledNavButton>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={5.5} order={{ xs: 1, md: 2 }}>
            <Box display="flex" justifyContent="center">
              <Box
                component={"img"}
                alt=""
                src={barfboy}
                width={{ xs: "100%", sm: "80%" }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default BuySection;
